import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../hook/useRulesContext";
import { Search, X } from "lucide-react";

export default function ControlSearch() {
    const { searchTerm, setSearchTerm } = useRulesContext();

    const clearSearch = () => {
        setSearchTerm("");
    };

    return (
        <div className="relative flex-1 sm:flex-initial">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
                type="text"
                placeholder={__(
                    "Search rules...",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-shortcode w-full pl-10 pr-10 py-2 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
                onClick={clearSearch}
                className={`absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 w-4 h-4 flex items-center justify-center transition-all duration-200 ${
                    searchTerm
                        ? "opacity-100 scale-100"
                        : "opacity-0 scale-75 pointer-events-none"
                }`}
                aria-label="Clear search"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
}
